module.exports = __webpack_public_path__ + "static/img/s-vivo-4.d1df811.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-vivo-4.png
// module id = 2Esn
// module chunks = 1